import './style.css';
import ReactDOM from 'react-dom/client';
import { Canvas } from '@react-three/fiber';
import * as THREE from 'three';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation
} from 'react-router-dom';
import { Html, OrbitControls, Stats } from '@react-three/drei'; // Import Stats
import LandingPageSphere from './components/LandingPageSphere.jsx';
import AboutMe from './components/AboutMe.jsx';
import Projects from './components/Projects.jsx';
import Projects2 from './components/Projects2.jsx';
import Contact2 from './components/Contact2.jsx';
import Shockwave from './Shockwave.jsx';
import LandingPageText from './components/LandingPageText.jsx';
import Experience from './components/Experience.jsx';

const root = ReactDOM.createRoot(document.querySelector('#root'));

const App = () => {
  return (
    <Router>
      <div className="canvas-container">
        {/* Navbar */}
        <div className="navbar">
          <Link to="/" className="navbar-title">
            My Portfolio
          </Link>
          <div className="navbar-buttons">
            <Link to="/aboutme" className="navbar-button">
              About Me
            </Link>
            <Link to="/projects" className="navbar-button">
              Projects(Slide)
            </Link>
            <Link to="/projects2" className="navbar-button">
              Projects(Plan)
            </Link>
            <Link to="/experience" className="navbar-button">
              Experience
            </Link>
            <Link to="/contact" className="navbar-button">
              Contact
            </Link>
          </div>
        </div>

        {/* Routes to different components */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutme" element={<CanvasPage component={AboutMe} />} />
          <Route
            path="/projects"
            element={<CanvasPage component={Projects} />}
          />
          <Route
            path="/projects2"
            element={<CanvasPage component={Projects2} />}
          />
          <Route
            path="/experience"
            element={<CanvasPage component={Experience} />}
          />
          <Route
            path="/contact"
            element={<CanvasPage component={Contact2} />}
          />
        </Routes>
      </div>
    </Router>
  );
};

// Home component with the default canvas and animations
const Home = () => {
  return (
    <>
      <Canvas
        style={{ background: '#1c1c1c' }}
        gl={{
          antialias: true,
          toneMapping: THREE.ACESFilmicToneMapping
        }}
        camera={{
          fov: 45,
          near: 0.1,
          far: 200,
          position: [0, 3, 5]
        }}
      >
        <directionalLight position={[1, 2, 3]} intensity={4.5} />
        <ambientLight intensity={1.5} />
        <OrbitControls enableZoom={true} />
        <LandingPageSphere />
        <Shockwave />
        <Stats />
      </Canvas>
      <LandingPageText />
    </>
  );
};

// Generic CanvasPage wrapper to render any component inside a Canvas and force re-render on route change
const CanvasPage = ({ component: Component }) => {
  const location = useLocation(); // React hook to get current path

  return (
    <Canvas
      key={location.pathname} // Key forces the Canvas to re-render on route change
      style={{ background: '#1C1C1C' }}
      gl={{
        antialias: true,
        toneMapping: THREE.ACESFilmicToneMapping
      }}
      camera={{
        fov: 45,
        near: 0.1,
        far: 200,
        position: [0, 0, 4]
      }}
    >
      <directionalLight position={[1, 2, 3]} intensity={4.5} />
      <ambientLight intensity={1.5} />
      <OrbitControls enableZoom />
      <Stats />
      {/* Render the passed component inside the Canvas */}
      <Component />
    </Canvas>
  );
};

root.render(<App />);
